import getConfig from 'next/config';
import { getCookie, clearAllCookies } from '../src/hooks/useCookie';
import { clearLocalStorage } from '../src/hooks/useLocalStorage';

const { publicRuntimeConfig } = getConfig();
const GTM_ID = publicRuntimeConfig.NEXT_PUBLIC_GTM_ID;

/**
 * pageview - Sends a virtual pageview event to Google Tag Manager by pushing to datalayer
 * @param {String} url - URL of the page visited
 */
const pageview = url => {
  window.dataLayer.push({
    event: 'pageview',
    page: url,
  });
};
const showModalWindow = (id, path) => {
  window.dataLayer.push({
    event: 'show_modal_window',
    modal_window_id: id,
    virtualURL: `${path}/${id}`,
  });
};
const viewItemListAnalytics = (itemListName, listData) => {
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      item_list_id: '',
      item_list_name: itemListName,
      items: [
        listData, // INSERT getRecommendedBBTariffs RESPONSE
      ],
    },
  });
};
const viewItemAnalytics = (itemListName, listData) => {
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      item_list_id: '',
      item_list_name: itemListName,
      items: [
        listData, // INSERT getHandset RESPONSE
      ],
    },
  });
};
const selectItemListAnalytics = (itemListId, itemListName, listData) => {
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'select_item',
    ecommerce: {
      item_list_id: itemListId,
      item_list_name: itemListName,
      items: [
        listData, // INSERT RESPONSE DATA
      ],
    },
  });
};

const addToCartAnalytics = cardData => {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'EUR',
      items: [
        cardData, // INSERT GETCART RESPONSE
      ],
    },
  });
};
const SIMTypeAnalytics = (SIMType, page) => {
  window.dataLayer.push({
    event: 'add_to_cart_sim_type',
    SIMType,
    page,
  });
};

const EIDAnalytics = (mobileBrand, page) => {
  window.dataLayer.push({
    event: 'EID_validated',
    mobileBrand,
    page,
  });
};

const removeFromCartAnalytics = cardData => {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      items: [
        cardData, // INSERT GETCART RESPONSE
      ],
    },
  });
};

const viewCartAnalytics = (cartType, cardData) => {
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'view_cart',
    ecommerce: {
      currency: 'EUR',
      cart: cartType,

      items: [
        cardData, // INSERT GETCART RESPONSE
      ],
    },
  });
};

const beginCheckoutAnalytics = cardData => {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'begin_checkout',
    ecommerce: {
      items: [
        cardData, // INSERT GETCART RESPONSE
      ],
    },
  });
};

const paymentAnalytics = (type, cardData) => {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_payment_info ',
    ecommerce: {
      currency: 'EUR',
      payment_type: type,
      items: [
        cardData, // INSERT GETCART RESPONSE
      ],
    },
  });
};

const purchaseAnalytics = cardData => {
  // window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      currency: 'EUR',
      items: [
        cardData, // INSERT GETCART RESPONSE
      ],
    },
  });
};
const purchaseCompleteAnalytics = data => {
  // window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase_complete',
    order_number: data, // INSERT PROSPECT_REFERENCE RESPONSE
  });
};
const preOrderInstallationAnalytics = (broadbandTechnology, path) => {
  window.dataLayer.push({
    event: 'pre_order_install',
    path: `${path}`,
    reference_id: getCookie('reference') ? getCookie('reference') : '',
    source: broadbandTechnology === 'NBI' ? 'getNEQResult' : 'getPrequalResults',
    broadbandTechnology: broadbandTechnology,
  });
};
const prequalPreOrderAnalytics = (broadbandTechnology, path) => {
  window.dataLayer.push({
    event: 'pre_order',
    path: `${path}`,
    reference_id: getCookie('reference') ? getCookie('reference') : '',
    source: broadbandTechnology === 'NBI' ? 'getNEQResult' : 'prequal',
    broadbandTechnology: broadbandTechnology,
  });
};
const dataRetrieval = (id, path) => {
  window.dataLayer.push({
    event: 'API_exception',
    modal_window_id: id,
    virtualURL: `${path}/${id}`,
    reference: getCookie('reference') ? getCookie('reference') : '',
    source: getCookie('api_failed') ? getCookie('api_failed') : '',
  });
  clearLocalStorage();
  clearAllCookies();
};

export {
  GTM_ID,
  pageview,
  showModalWindow,
  addToCartAnalytics,
  SIMTypeAnalytics,
  EIDAnalytics,
  viewItemListAnalytics,
  selectItemListAnalytics,
  removeFromCartAnalytics,
  viewCartAnalytics,
  beginCheckoutAnalytics,
  paymentAnalytics,
  purchaseAnalytics,
  viewItemAnalytics,
  purchaseCompleteAnalytics,
  dataRetrieval,
  preOrderInstallationAnalytics,
  prequalPreOrderAnalytics,
};
